import React, { memo } from 'react';

import { Typography } from '@sravni/react-design-system';

import DownloadIcon from '../Icons/DownloadIcon';

import style from './style.module.scss';

interface IProps {
  link: string;
  text: string;
}

const DownloadDocument: React.FC<IProps> = memo(({ link, text }) => (
  <Typography.Link href={link} className={style.terms} target="_blank">
    <div className={style.picture}>
      <DownloadIcon />
    </div>
    <div className={style.termText}>{text}</div>
  </Typography.Link>
));

export default DownloadDocument;
